import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { ToasterModule } from './../../node_modules/angular5-toaster/angular5-toaster';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HomeComponent } from './pages/home.component';
import { AboutComponent } from './pages/about.component';
import { ConceptComponent } from './pages/concept.component';
import { NewsComponent } from './pages/news.component';
import { ArticleComponent } from './pages/article.component';
import { FeedComponent } from './pages/feed.component';
import { AccountComponent } from './pages/account.component';
import { RoutesComponent } from './pages/routes.component';
import { InteractiveMapComponent } from './pages/interactive-map.component';
import { ResponsibilityComponent } from './pages/responsibility.component';
import { ParticipantsComponent } from './pages/participants.component';
// import { FAQComponent } from './pages/faq.component';
import { PayComponent } from './pages/pay.component';
import { ScheduleComponent } from './pages/schedule.component';
import { VacancyComponent } from './pages/vacancy.component';
import { RuleComponent } from './pages/rule.component';
import { PolicyComponent } from './pages/policy.component';
import { PaymentInfoComponent } from './pages/payment-info.component';

import { TicketComponent } from './pages/ticket.component';

import { AutofocusDirective } from './common/autofocus.directive';
import { DatepickerComponent } from './common/datepicker.component';
import { LoaderComponent } from './common/loader.component';
import { ModalComponent } from './common/modal.component';
import { MapComponent } from './common/map.component';
import { InfoPanelComponent } from './common/info-panel.component';
import { FilterPanelComponent } from './common/filter-panel.component';
import { InfoFilterPanelComponent } from './common/info-filter-panel.component';
import { RouteInfoPanelComponent } from './common/route-info-panel.component';
import { LegendPanelComponent } from './common/legend-panel.component';
import { BuiltRouteInfoPanelComponent } from './common/built-route-info-panel.component';
import { SearchStopComponent } from './common/search-stop.component';
import { TicketPaymentComponent } from './common/ticket/ticket-payment.component';
import { TicketEmailComponent } from './common/ticket/ticket-email.component';
import { TicketPassComponent } from './common/ticket/ticket-pass.component';
import { TicketSelectorComponent } from './common/ticket/ticket-selector.component';
import { TicketDisplayComponent } from './common/ticket/ticket-display.component';
import { ImgComponent } from './common/img.component';

import {
  StopCountTextPipe, TransferCountTextPipe, FilterArticleItems, TicketMomentPipe,
  TicketActiveTripsPipe, TicketUsedTripsPipe, TicketStatusDisplayPipe, TicketIsActivePipe,
  TicketPaymentStatusDisplayPipe, TicketActiveTripsCountPipe, TripCountTextPipe,
  ShortTripCountTextPipe, TicketBonusOffersPipe, TicketBonusOffersTextPipe, TicketOffersTextPipe
} from './common/pipe-index';

import { TramApiService } from './tram-api.service';
import { TramPositioningService } from './tram-positioning.service';
import { TramCollector } from './common/tram-collector';
import { StopCollector } from './common/stop-collector';
import { RailCollector } from './common/rail-collector';
import { RouteCollector } from './common/route-collector';
import { ScheduleCollector } from './common/schedule-collector';
import { PointOfInterestCollector } from './common/poi-collector';
import { PanelDataExchangeService } from './common/panel-data-exchange.service';

import { QRCodeModule } from 'angularx-qrcode';
import { TextMaskModule } from 'angular2-text-mask';
import { StorageService } from './storage.service';
import { LoginComponent } from './common/account/login.component';
import { RegistrationComponent } from './common/account/registration.component';
import { RecoverPasswordComponent } from './pages/recover-password.component';
import { RecoverPasswordEmailComponent } from './common/account/recover-password-email.component';
import { ChangePasswordComponent } from './common/account/change-password.component';
import { AgreementComponent } from './pages/agreement.component';
import { PaymentPolicyComponent } from './pages/payment-policy.component';
import { BarRatingComponent } from './common/rating/component/bar-rating.component';
import { BarRatingPipe } from './common/rating/pipe/bar-rating.pipe';
import { TokenInterceptor, SecureImagePipe } from './providers/token.interceptor';
import { ReviewComponent } from './common/review/review.component';
import { CommentComponent } from './common/review/comment.component';
import { GodCommentFormComponent } from './common/review/god-comment-form.component';
import { CommentFormComponent } from './common/review/comment-form.component';
import { DeleteConfirmationComponent } from './common/delete-confirmation.component';
import { ReviewService } from './providers/review.service';
import { ReviewFormComponent } from './common/review/review-form.component';
import { SearchInputComponent } from './common/search-input.component';
import { ChangeNameFormComponent } from './common/account/change-name-form.component';
import { LoadMoreFooterComponent } from './common/load-more-footer.component';
import { VacancyService } from './providers/vacancy.service';
import { PositionComponent } from './common/position.component';
import { NewsService } from './providers/news.service';
import { QuestionService } from './providers/question.service';
import { TicketService } from './providers/ticket.service';

@NgModule({
  declarations: [
    AppComponent,
    AutofocusDirective,
    DatepickerComponent,
    LoaderComponent,
    ModalComponent,
    MapComponent,
    InfoPanelComponent,
    RouteInfoPanelComponent,
    FilterPanelComponent,
    LegendPanelComponent,
    BuiltRouteInfoPanelComponent,
    InfoFilterPanelComponent,
    SearchStopComponent,
    TicketPaymentComponent,
    TicketEmailComponent,
    TicketPassComponent,
    SecureImagePipe,
    TicketSelectorComponent,
    TicketBonusOffersPipe,
    TicketBonusOffersTextPipe,
    TicketOffersTextPipe,
    TripCountTextPipe,
    TicketDisplayComponent,
    TicketStatusDisplayPipe,
    TicketIsActivePipe,
    TicketPaymentStatusDisplayPipe,
    TicketActiveTripsCountPipe,
    ShortTripCountTextPipe,
    ImgComponent,
    HomeComponent,
    AboutComponent,
    NewsComponent,
    ArticleComponent,
    FeedComponent,
    AccountComponent,
    RoutesComponent,
    PayComponent,
    InteractiveMapComponent,
    ConceptComponent,
    ResponsibilityComponent,
    ParticipantsComponent,
    // FAQComponent,
    ScheduleComponent,
    PositionComponent,
    VacancyComponent,
    RuleComponent,
    PolicyComponent,
    PaymentInfoComponent,
    TicketComponent,
    TicketMomentPipe,
    TicketActiveTripsPipe,
    TicketUsedTripsPipe,
    StopCountTextPipe,
    TransferCountTextPipe,
    FilterArticleItems,
    LoginComponent,
    RegistrationComponent,
    RecoverPasswordComponent,
    RecoverPasswordEmailComponent,
    ChangePasswordComponent,
    AgreementComponent,
    PaymentPolicyComponent,
    BarRatingComponent,
    BarRatingPipe,
    ReviewComponent,
    CommentComponent,
    GodCommentFormComponent,
    CommentFormComponent,
    DeleteConfirmationComponent,
    ReviewFormComponent,
    SearchInputComponent,
    ChangeNameFormComponent,
    LoadMoreFooterComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    QRCodeModule,
    TextMaskModule,
    AppRoutingModule,
    ToasterModule
  ],
  providers: [TramApiService,
    TramPositioningService,
    TramCollector,
    RailCollector,
    StopCollector,
    PointOfInterestCollector,
    RouteCollector,
    ScheduleCollector,
    PanelDataExchangeService,
    StorageService,
    ReviewService,
    VacancyService,
    NewsService,
    QuestionService,
    TicketService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/app.module.ts